import React from "react";
import { PageTitle } from "../../../../_metronic/layout/core";
import GenericReport from "../GenericReport";

const DeletedTreatmentsPage: React.FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[{ title: "Reports", path: "/reports", isActive: false }]}>
        Deleted Treatments
      </PageTitle>
      <GenericReport reportId={11} />
    </>
  );
};

export default DeletedTreatmentsPage;
